import React from "react";
import "./About.css";
import Navbar from "../Include/Navbar";
import Footer from "../Include/Footer";

function About() {
  return (<>
  <Navbar />
    <div className="about-page">
      <div className="container">
        <h1>About Us</h1>
        <p className="intro">
          Welcome to <strong>Dharmiq App</strong>, a dynamic online streaming platform owned and operated by Innosutra AI Private Limited. At <strong>Dharmiq App</strong>, our goal is to redefine how audiences across India enjoy digital entertainment. We bring together a wide spectrum of content—including movies, web series, documentaries, short films, and original productions—so you can watch what you love, whenever you want.
        </p>

        <section className="section">
          <h2>Our Vision</h2>
          <p>Delivering a Premium Entertainment Experience for Everyone in India</p>
          <p>
            We believe entertainment should be accessible, engaging, and seamless. That’s why our platform is built using modern technology to ensure smooth performance, personalized discovery, and a diverse content lineup tailored to every viewer.
          </p>
        </section>

        <section className="section">
          <h2>Why Choose Dharmiq App ?</h2>
          <div className="features-grid">
            <div className="info">
              <h3>Diverse Content Collection</h3>
              <p>
                Explore an extensive library featuring films, series, documentaries, short-form content, live programming, and exclusive originals across multiple genres and languages—something for every taste and mood.
              </p>
            </div>

            <div className="info">
              <h3>Intuitive User Experience</h3>
              <p>
                Our platform is designed with simplicity and convenience in mind. Enjoy easy navigation, smart recommendations, and a viewing experience tailored to your preferences.
              </p>
            </div>

            <div className="info">
              <h3>Superior Streaming Quality</h3>
              <p>
                Experience clear visuals and high-quality audio with optimized streaming performance across devices, ensuring a consistently enjoyable watch.
              </p>
            </div>

            <div className="info">
              <h3>Blend of Local and Global Content</h3>
              <p>
                We celebrate India’s cultural richness while also bringing you content from around the world, offering a balanced mix of regional and international entertainment.
              </p>
            </div>

            <div className="info">
              <h3>Continuous Innovation</h3>
              <p>
                We are committed to evolving with the latest trends in digital entertainment, constantly improving our platform to deliver better features and richer experiences.
              </p>
            </div>

            <div className="info">
              <h3>User-First Approach</h3>
              <p>
                Your experience matters to us. We actively consider user feedback to refine and enhance our services over time.
              </p>
            </div>

            <div className="info">
              <h3>Multi-Device Accessibility</h3>
              <p>
                Access <strong>Dharmiq App</strong> anytime, anywhere—on smartphones, tablets, and other supported devices—allowing you to switch seamlessly between screens.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
    <Footer/>
    </>
  );
}

export default About;